export const ACTION_TYPE_LABELS: Record<string, string> = {
    API_KEY_RECREATE: "API-ключ: перевыпуск",
    API_KEY_UPDATE: "API-ключ: изменение",
    AVIABOOKING_BOOKING_CANCEL: "Авиабилеты: отмена бронирования",
    AVIABOOKING_BOOKING_PAY: "Авиабилеты: оплата бронирования",
    AVIABOOKING_FLIGHT_BOOK: "Авиабилеты: бронирование рейса",
    AVIABOOKING_PRICE_CHANGE_ACKNOWLEDGE: "Авиабилеты: подтверждение изменения цены",
    AVIABOOKING_SAVED_DOCUMENT_DELETE: "Авиабилеты: удаление документа",
    CHANNEL_CREATE: "Канал: создание",
    CHANNEL_UPDATE: "Канал: изменение",
    COMMUNITY_DEFAULT_GROUP_UPDATE: "Сообщество: изменение группы по умолчанию",
    COMMUNITY_WEBSITE_INFO_DELETE: "Сообщество: удаление данных сайта",
    COMMUNITY_WEBSITE_INFO_UPDATE: "Сообщество: изменение данных сайта",
    GROUP_BLOCK_USERS_PROHIBITED_SET: "Группа: настройка запрета блокировки",
    GROUP_BONUS_ACCRUE: "Группа: начисление бонусов",
    GROUP_CREATE: "Группа: создание",
    GROUP_DELETE: "Группа: удаление",
    GROUP_UPDATE: "Группа: изменение",
    GROUP_USER_ADD: "Группа: добавление пользователя",
    GROUP_USER_REMOVE: "Группа: удаление пользователя",
    INTEGRATION_CREATE: "Интеграция: создание",
    INTEGRATION_DELETE: "Интеграция: удаление",
    INTEGRATION_UPDATE: "Интеграция: изменение",
    INVITATION_LINK_CREATE: "Приглашения: создание ссылки",
    INVITATION_LINK_DELETE: "Приглашения: удаление ссылки",
    INVITATION_QR_CREATE: "Приглашения: создание QR-кода",
    INVOICE_CANCEL: "Счёт: отмена",
    INVOICE_CREATE: "Счёт: создание",
    JOB_APPLICATION_APPROVE: "Трудоустройство: одобрение отклика",
    JOB_APPLICATION_REJECT: "Трудоустройство: отклонение отклика",
    JOB_OPENING_CREATE: "Вакансия: создание",
    JOB_OPENING_DELETE: "Вакансия: удаление",
    JOB_OPENING_UPDATE: "Вакансия: изменение",
    LOYALTY_LEVEL_CREATE: "Уровень лояльности: создание",
    LOYALTY_LEVEL_DELETE: "Уровень лояльности: удаление",
    LOYALTY_LEVEL_UPDATE: "Уровень лояльности: изменение",
    NOTIFICATION_BROADCAST_SEND: "Рассылка: отправка",
    ONBOARDING_DASHBOARD_CARD_CREATE: "Онбординг: создание карточки",
    ONBOARDING_PROFILE_CONTACT_UPDATE: "Онбординг: изменение контактов",
    ONBOARDING_PROFILE_SUBMIT: "Онбординг: отправка профиля",
    PARTNER_DISCOUNT_CREATE: "Скидка партнёра: создание",
    PARTNER_DISCOUNT_DELETE: "Скидка партнёра: удаление",
    PARTNER_DISCOUNT_UPDATE: "Скидка партнёра: изменение",
    PHONE_WHITELIST_BULK_CREATE: "Белый список: массовое добавление номеров",
    PHONE_WHITELIST_BULK_CREATE_FROM_CSV: "Белый список: импорт номеров из CSV",
    PHONE_WHITELIST_DISABLE: "Белый список: выключение",
    PHONE_WHITELIST_ENABLE: "Белый список: включение",
    PHONE_WHITELIST_ENTRY_CREATE: "Белый список: добавление номера",
    PHONE_WHITELIST_ENTRY_DELETE: "Белый список: удаление номера",
    PROFILE_FIELD_CREATE: "Поле профиля: создание",
    PROFILE_FIELD_DELETE: "Поле профиля: удаление",
    PROFILE_FIELD_UPDATE: "Поле профиля: изменение",
    PROMOTION_CREATE: "Акция: создание",
    PROMOTION_DELETE: "Акция: удаление",
    PROMOTION_UPDATE: "Акция: изменение",
    RANDOMIZER_CAMPAIGN_ANNOUNCE: "Розыгрыш: публикация анонса",
    RANDOMIZER_CAMPAIGN_CREATE: "Розыгрыш: создание",
    RANDOMIZER_CAMPAIGN_POST_RESULTS: "Розыгрыш: публикация результатов",
    RANDOMIZER_CAMPAIGN_TOGGLE: "Розыгрыш: изменение активности",
    RESTAURANT_MENU_CREATE: "Меню ресторана: создание",
    RESTAURANT_MENU_DELETE: "Меню ресторана: удаление",
    RESTAURANT_MENU_IMAGE_DELETE: "Меню ресторана: удаление изображения",
    RESTAURANT_MENU_ITEM_AVAILABILITY_SET: "Меню ресторана: доступность позиции",
    RESTAURANT_MENU_ITEM_IMAGE_ADD_URL: "Меню ресторана: добавление изображения по ссылке",
    RESTAURANT_MENU_ITEM_IMAGE_REORDER: "Меню ресторана: изменение порядка изображений",
    RESTAURANT_MENU_ITEM_IMAGE_UPLOAD: "Меню ресторана: загрузка изображения",
    RESTAURANT_MENU_LANGUAGES_SET: "Меню ресторана: настройка языков",
    RESTAURANT_MENU_MODIFIER_AVAILABILITY_SET: "Меню ресторана: доступность модификатора",
    RESTAURANT_MENU_OVERRIDE_DELETE: "Меню ресторана: удаление переопределения",
    RESTAURANT_MENU_TRANSLATION_DELETE: "Меню ресторана: удаление перевода",
    RESTAURANT_MENU_TRANSLATION_SET: "Меню ресторана: изменение перевода",
    RESTAURANT_MENU_UPDATE: "Меню ресторана: изменение",
    SOCIAL_GROUP_CREATE: "Социальная группа: создание",
    SOCIAL_GROUP_DELETE: "Социальная группа: удаление",
    SOCIAL_GROUP_UPDATE: "Социальная группа: изменение",
    SOCIAL_GROUP_USER_ADD: "Социальная группа: добавление пользователя",
    SOCIAL_GROUP_USER_REMOVE: "Социальная группа: удаление пользователя",
    SOCIAL_PROGRAM_DELETE: "Социальная программа: удаление",
    SOCIAL_PROGRAM_DONATE_TO_PROGRAM: "Социальная программа: пожертвование программе",
    SOCIAL_PROGRAM_DONATE_TO_USER: "Социальная программа: пожертвование пользователю",
    SOCIAL_PROGRAM_DONATION_DISTRIBUTE: "Социальная программа: распределение пожертвования",
    SOCIAL_PROGRAM_FOUNDATION_ACCRUE: "Социальная программа: начисление фонду",
    SOCIAL_PROGRAM_FOUNDATION_CREATE: "Социальная программа: создание фонда",
    SOCIAL_PROGRAM_GROUP_CREATE: "Социальная программа: создание группы",
    SOCIAL_PROGRAM_GROUP_DELETE: "Социальная программа: удаление группы",
    SOCIAL_PROGRAM_GROUP_INVITATION_DELETE: "Соцпрограмма: удаление приглашения в группу",
    SOCIAL_PROGRAM_GROUP_INVITE_CREATE: "Социальная программа: приглашение в группу",
    SOCIAL_PROGRAM_GROUP_MEMBER_ADD: "Социальная программа: добавление участника группы",
    SOCIAL_PROGRAM_GROUP_MEMBER_REMOVE: "Социальная программа: удаление участника группы",
    SOCIAL_PROGRAM_MEMBER_REMOVE: "Социальная программа: удаление участника",
    SOCIAL_PROGRAM_UPDATE: "Социальная программа: изменение",
    SOCIAL_PROGRAM_USER_CREATION_BLOCK: "Социальная программа: запрет создания пользователей",
    SOCIAL_PROGRAM_USER_CREATION_UNBLOCK: "Социальная программа: разрешение создания пользователей",
    TRADING_BILLING_CREATE: "Торговля: создание начисления",
    TRADING_BONUS_DEBIT: "Торговля: списание бонусов",
    TRADING_BONUS_EARN: "Торговля: начисление бонусов",
    TRADING_ORDER_CREATE: "Торговля: создание заказа",
    USER_BLOCK: "Пользователь: блокировка",
    USER_BONUS_ACCRUE: "Пользователь: начисление бонусов",
    USER_DELETE: "Пользователь: удаление",
    USER_INVITATION_BULK_CREATE: "Пользователь: массовое создание приглашений",
    USER_INVITATION_CREATE: "Пользователь: создание приглашения",
    USER_INVITATION_TEMPLATE_UPDATE: "Пользователь: изменение шаблона приглашения",
    USER_PROFILE_UPDATE: "Пользователь: изменение профиля",
    USER_RECOVER: "Пользователь: восстановление",
    USER_UNBLOCK: "Пользователь: разблокировка",
    VISIBILITY_ACL_DELETE: "ACL видимости: удаление правила",
    VISIBILITY_ACL_SET: "ACL видимости: настройка правила",
}

export const resolveActionTypeLabel = (actionType: string): string => {
    return ACTION_TYPE_LABELS[actionType] ?? actionType
}
